export const yearOptions = [
  { label: "2001", value: "2001" },
  { label: "2002", value: "2002" },
  { label: "2003", value: "2003" },
  { label: "2004", value: "2004" },
  { label: "2005", value: "2005" },
  { label: "2006", value: "2006" },
  { label: "2007", value: "2007" },
  { label: "2008", value: "2008" },
  { label: "2009", value: "2009" },
  { label: "2010", value: "2010" },
  { label: "2011", value: "2011" },
  { label: "2012", value: "2012" },
  { label: "2013", value: "2013" },
  { label: "2014", value: "2014" },
  { label: "2015", value: "2015" },
  { label: "2016", value: "2016" },
  { label: "2017", value: "2017" },
  { label: "2018", value: "2018" },
  { label: "2019", value: "2019" },
  { label: "2020", value: "2020" },
  { label: "2021", value: "2021" },
  { label: "2022", value: "2022" }
];

export const regionOptions = [
  { label: "North America", value: "North America" },
  { label: "South America", value: "South America" },
  { label: "Europe", value: "Europe" },
  { label: "Asia", value: "Asia" },
  { label: "Africa", value: "Africa" },
  { label: "Australia", value: "Australia" }
];

export const locationOptions = [
  { label: "New York", value: "New York" },
  { label: "Los Angeles", value: "Los Angeles" },
  { label: "Chicago", value: "Chicago" },
  { label: "Houston", value: "Houston" },
  { label: "Phoenix", value: "Phoenix" },
  { label: "Philadelphia", value: "Philadelphia" },
  { label: "San Antonio", value: "San Antonio" },
  { label: "San Diego", value: "San Diego" },
  { label: "Dallas", value: "Dallas" },
  { label: "San Jose", value: "San Jose" },
  { label: "Austin", value: "Austin" },
  { label: "Jacksonville", value: "Jacksonville" },
  { label: "Fort Worth", value: "Fort Worth" },
  { label: "Columbus", value: "Columbus" },
  { label: "Charlotte", value: "Charlotte" },
  { label: "San Francisco", value: "San Francisco" },
  { label: "Indianapolis", value: "Indianapolis" },
  { label: "Seattle", value: "Seattle" },
  { label: "Denver", value: "Denver" },
  { label: "Washington", value: "Washington" },
  { label: "Boston", value: "Boston" },
  { label: "El Paso", value: "El Paso" },
  { label: "Nashville", value: "Nashville" },
  { label: "Oklahoma City", value: "Oklahoma City" },
  { label: "Las Vegas", value: "Las Vegas" },
  { label: "Detroit", value: "Detroit" },
  { label: "Portland", value: "Portland" },
  { label: "Memphis", value: "Memphis" },
  { label: "Louisville", value: "Louisville" },
  { label: "Milwaukee", value: "Milwaukee" },
  { label: "Baltimore", value: "Baltimore" },
  { label: "Albuquerque", value: "Albuquerque" },
  { label: "Tucson", value: "Tucson" },
  { label: "Fresno", value: "Fresno" }
];

export const currencyOptions = [
  { label: "USD", value: "USD" },
  { label: "EUR", value: "EUR" },
  { label: "GBP", value: "GBP" },
  { label: "JPY", value: "JPY" },
  { label: "CNY", value: "CNY" },
  { label: "INR", value: "INR" },
  { label: "AUD", value: "AUD" },
  { label: "CAD", value: "CAD" },
  { label: "CHF", value: "CHF" },
  { label: "SEK", value: "SEK" },
  { label: "NZD", value: "NZD" },
  { label: "MXN", value: "MXN" },
  { label: "SGD", value: "SGD" },
  { label: "HKD", value: "HKD" },
  { label: "NOK", value: "NOK" },
  { label: "KRW", value: "KRW" },
  { label: "TRY", value: "TRY" },
  { label: "RUB", value: "RUB" },
  { label: "BRL", value: "BRL" },
  { label: "ZAR", value: "ZAR" },
  { label: "TWD", value: "TWD" },
  { label: "DKK", value: "DKK" },
  { label: "PLN", value: "PLN" },
  { label: "THB", value: "THB" },
  { label: "IDR", value: "IDR" },
  { label: "HUF", value: "HUF" },
  { label: "CZK", value: "CZK" },
  { label: "ILS", value: "ILS" },
  { label: "CLP", value: "CLP" },
  { label: "PHP", value: "PHP" },
  { label: "AED", value: "AED" },
  { label: "COP", value: "COP" },
  { label: "SAR", value: "SAR" },
  { label: "MYR", value: "MYR" }
];

export const stageOptions = [
  { label: "Seed", value: "Seed" },
  { label: "Series A", value: "Series A" },
  { label: "Series B", value: "Series B" },
  { label: "Series C", value: "Series C" },
  { label: "Series D", value: "Series D" },
  { label: "Series E", value: "Series E" },
  { label: "Series F", value: "Series F" },
  { label: "Series G", value: "Series G" },
  { label: "Series H", value: "Series H" },
  { label: "Series I", value: "Series I" },
  { label: "Series J", value: "Series J" },
  { label: "Series K", value: "Series K" },
  { label: "Series L", value: "Series L" },
  { label: "Series M", value: "Series M" },
  { label: "Series N", value: "Series N" },
  { label: "Series O", value: "Series O" },
  { label: "Series P", value: "Series P" },
  { label: "Series Q", value: "Series Q" },
  { label: "Series R", value: "Series R" },
  { label: "Series S", value: "Series S" },
  { label: "Series T", value: "Series T" },
  { label: "Series U", value: "Series U" },
  { label: "Series V", value: "Series V" },
  { label: "Series W", value: "Series W" },
  { label: "Series X", value: "Series X" },
  { label: "Series Y", value: "Series Y" },
  { label: "Series Z", value: "Series Z" }
];
export const investorRoundOptions = [
  { label: "Round1", value: "Round1" },
  { label: "Round2", value: "Round2" },
  { label: "Round3", value: "Round3" },
  { label: "Round4", value: "Round4" },
  { label: "Round5", value: "Round5" }
];

export const dateOptions = [
  { label: "01/01/2023", value: "01/01/2023" },
  { label: "01/02/2023", value: "01/02/2023" },
  { label: "01/03/2023", value: "01/03/2023" },
  { label: "01/04/2023", value: "01/04/2023" },
  { label: "01/05/2023", value: "01/05/2023" },
  { label: "01/06/2023", value: "01/06/2023" },
  { label: "01/07/2023", value: "01/07/2023" },
  { label: "01/08/2023", value: "01/08/2023" },
  { label: "01/09/2023", value: "01/09/2023" },
  { label: "01/10/2023", value: "01/10/2023" }
];
